import styled from 'styled-components'
import { Block, Skeleton } from '@mote/ui'

export const ToteCardSkeleton = () => {
  return (
    <Root gap={16}>
      <Skeleton.Text noOfLines={1} skeletonHeight={17} />
      <Block gap={10} spreadX>
        <ButtonSkeleton />
        <ButtonSkeleton />
      </Block>
    </Root>
  )
}

const Root = styled(Block)`
  margin-top: 8px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #f6f6f9;
  box-sizing: border-box;
  background-color: #fff;
`

const ButtonSkeleton = styled(Skeleton)`
  height: 40px;
`
